module.exports = __webpack_public_path__ + "img/indu_active_7.b3650bd2.png";